
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  export default {
    components: {
      DialogsBaseSection,
      CheckboxRichText: () => import('@/components/elements/CheckboxRichText'),
    },
    mixins: [ScreenSize],
    props: {
      organization: {
        type: Object,
        require: true,
        default: () => {},
      },
    },
    data() {
      return {
        buttonDisabled: false,
        questionDialog: false,
        section: {},
        availableTopics: [
          //this.$t('organization.question_topics_my_jobs'),
          //this.$t('organization.question_topics_my_applications'),
          //this.$t('organization.question_topics_current_job_offers'),
          this.$t('organization.question_topics_project_request_staff'),
          this.$t('organization.question_topics_project_request_conception'),
          this.$t('organization.question_topics_project_request_full_service'),
          this.$t('organization.question_topics_misc'),
        ],
        questionData: {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          message: '',
          checkbox: false,
        },
      };
    },
    async fetch() {
      const dialogSection = await this.$cachedStrapi
        .find('organization-question-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
      dialogSection.title = dialogSection.title.replace(
        /%organization_name/g,
        this.organization.name
      );
      dialogSection.intro_text = dialogSection.intro_text.replace(
        /%organization_name/g,
        this.organization.name
      );
      this.section = dialogSection;
    },
    watch: {
      '$auth.loggedIn': function () {
        this.setValuesForLoggedUser();
      },
    },
    mounted() {
      this.setValuesForLoggedUser();
    },
    methods: {
      setValuesForLoggedUser() {
        if (this.$auth.loggedIn) {
          if (this.$auth.user.candidateProfile.fullName) {
            this.questionData.name = this.$auth.user.candidateProfile.fullName;
          }
          if (this.$auth.user.email) {
            this.questionData.email = this.$auth.user.email;
          }
          Object.keys(this.$auth.user.candidateProfile.communicationData).map(
            (key) => {
              if (
                this.$auth.user.candidateProfile.communicationData[key].type ===
                  'communication_data_type.mobile' ||
                this.$auth.user.candidateProfile.communicationData[key].type ===
                  'communication_data_type.tel'
              ) {
                this.questionData.phone =
                  this.$auth.user.candidateProfile.communicationData[key].value;
              }
            }
          );
        }
      },
      resetForm() {
        this.$refs.organizationQuestionForm.resetValidation();
        this.$refs.organizationQuestionForm.$children.forEach((child) => {
          if (Object.prototype.hasOwnProperty.call(child, 'reset')) {
            child.reset();
          }
        });
        this.questionData = {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          message: '',
          checkbox: false,
        };
        this.setValuesForLoggedUser();
      },
      async sendQuestion() {
        this.buttonDisabled = true;
        setTimeout(() => {
          this.buttonDisabled = false;
        }, 5000);
        let questionEndpoint =
          'api/organization/organizationContactedFromVisitor';
        const trackingParams = this.questionData;
        trackingParams.organizationId = this.organization.id;
        const endpointParams = {
          name: this.questionData.name,
          company: this.questionData.company,
          email: this.questionData.email,
          phone: this.questionData.phone,
          topic: this.questionData.topic,
          message: this.questionData.message,
          checkbox: this.questionData.checkbox,
        };

        if (this.$auth.loggedIn) {
          questionEndpoint = 'api/organization/organizationContactedFromUser';
          endpointParams.candidateAccountId = this.$auth.user.id;
        }

        await this.$store
          .dispatch(questionEndpoint, {
            id: this.organization.id,
            data: endpointParams,
          })
          .then(() => {
            this.$notifications.showNotification({
              message: this.$t('organization.question_success'),
              color: 'success',
              timeout: 3000,
            });
            this.$emitWithClientData(
              Events.OrganizationContacted,
              trackingParams
            );
            this.questionDialog = false;
            this.resetForm();
          })
          .catch((e) => {
            if (e.response.status !== 200) {
              this.$notifications.showNotification({
                message: this.$t('organization.question_error'),
                color: 'error',
                timeout: 5000,
              });
            }
          });
      },
    },
  };
